import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { NGXLogger } from "ngx-logger";
import { SignInActionTypes, UpdateUserAction } from "src/app/components/allusers/signin/signin.actions";
import { SignInState } from "src/app/components/allusers/signin/signin.model";
import { getSignedInUser, getSignIn } from "src/app/components/allusers/signin/signin.selector";
import { User } from "src/app/models/user.model";
import { AuthService } from "src/app/services/auth-service/auth.service";
import { RegmembersService } from "src/app/services/regmembers.service";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"]
})
export class ProfileComponent implements OnInit {
  profile: FormGroup;
  successMessage: string;
  errorMessage: string;
  currentUser: User;
  getSignIn$ = this.loginStore.pipe(select(getSignIn));
  signIn: SignInState;
  
  constructor(
    private formBuilder: FormBuilder,
    private loginStore: Store<SignInState>,
    private logger: NGXLogger,
    private regmemService: RegmembersService,
    private router: Router,
    private route: ActivatedRoute
  ) { }
  
  ngOnInit() {
    // Initialize form immediately with empty values
    this.profile = this.formBuilder.group({
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      dob: ['', [Validators.pattern(/^\d{2}\/\d{2}\/\d{4}$/)]],
      licenseinstate: ['', Validators.required],
    });

    this.route.queryParams.subscribe(params => {
      if (params['error']) {
        this.errorMessage = params['error'];
      }
    });

    // Update form when user data is available
    this.loginStore.pipe(select(getSignedInUser)).subscribe(user => {
      this.currentUser = user;
      if (this.currentUser) {
        // Update form values with user data
        this.profile.patchValue({
          fname: this.currentUser.fname || '',
          lname: this.currentUser.lname || '',
          dob: this.formatDob(this.currentUser.dob),
          licenseinstate: this.currentUser.licenseinstate || '',
        });
      }
    });
    this.getSignIn$.subscribe(signIn => {
      this.signIn = signIn;
    });
  }

  async onSubmit() {
    this.clearMessages();
    const updatedUserModel = {
      ...this.currentUser,
      licenseinstate: this.profile.value.licenseinstate ? this.profile.value.licenseinstate.toUpperCase() : null,
      fname: this.profile.value.fname,
      lname: this.profile.value.lname,
      dob: this.profile.value.dob ? this.profile.value.dob : null,
    };

    try {
      const updatedUser = await this.regmemService.updateRegmem(this.currentUser.membername, updatedUserModel);
      this.successMessage = "Profile saved Successfully";
      this.loginStore.dispatch(new UpdateUserAction({ ...this.signIn, user: updatedUser } as SignInState));
    } catch (error) {
      this.logger.error(`Error updating profile: ${error}`);
      this.errorMessage = "Error updating profile";
    }
  }

  clearMessages() {
    this.successMessage = null;
    this.errorMessage = null;
  }

  goToCourses() {
    this.router.navigate(['courses']);
  }

  private formatDob(value: string | null): string {
    if (!value) {
      return '';
    }
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      return value;
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }
}
